import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import QuickAccessCard from './QuickAccessCard';

/**
 * @param {Array} cardsData - Arreglo de objetos, cada uno con:
 *    {
 *      icon: JSX.Element,
 *      title: string,
 *      description: string,
 *      extraInfo: string,
 *      route: string,
 *      pdf: string
 *    }
 */

const QuickCards = ({ cardsData = [] }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: { xs: '16px', md: '48px' },
        margin: { xs: '32px 16px', md: '16px 16px' },
        flexDirection: { xs: 'column', md: 'row' }, // <--- Apila en columna en mobile
        alignItems: { xs: 'stretch', md: 'center' }, // <--- Estira tarjetas en mobile
      }}
    >
      {cardsData.map((card, index) => (
        <QuickAccessCard
          key={index}
          icon={card.icon || ""}
          title={card.title}
          description={card.description || ""}
          extraInfo={card.extraInfo || ""}
          route={card.route || ""}
          pdf={card.pdf || null}
        />
      ))}
    </Box>
  );
};

QuickCards.propTypes = {
  cardsData: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      extraInfo: PropTypes.string,
      route: PropTypes.string,
      pdf: PropTypes.string,
    })
  ),
};

export default QuickCards;